var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8702 28.5149L3.8402 28.5449C3.4352 27.6599 3.1802 26.6549 3.0752 25.5449C3.1802 26.6399 3.4652 27.6299 3.8702 28.5149Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5007 15.5697C15.4723 15.5697 17.0707 13.9713 17.0707 11.9997C17.0707 10.028 15.4723 8.42969 13.5007 8.42969C11.529 8.42969 9.93066 10.028 9.93066 11.9997C9.93066 13.9713 11.529 15.5697 13.5007 15.5697Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.285 3.00098H11.715C6.255 3.00098 3 6.25598 3 11.716V24.286C3 25.921 3.285 27.346 3.84 28.546C5.13 31.396 7.89 33.001 11.715 33.001H24.285C29.745 33.001 33 29.746 33 24.286V20.851V11.716C33 6.25598 29.745 3.00098 24.285 3.00098ZM30.555 18.751C29.385 17.746 27.495 17.746 26.325 18.751L20.085 24.106C18.915 25.111 17.025 25.111 15.855 24.106L15.345 23.686C14.28 22.756 12.585 22.666 11.385 23.476L5.775 27.241C5.445 26.401 5.25 25.426 5.25 24.286V11.716C5.25 7.48598 7.485 5.25098 11.715 5.25098H24.285C28.515 5.25098 30.75 7.48598 30.75 11.716V18.916L30.555 18.751Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.3619353be07b7e7089252f9d3a319083.svg";
export { ForwardRef as ReactComponent };